// Parse/formatação do metadata_* de imagem (capa, capa mobile, fundo) —
// guardado no banco como string JSON.stringify (ver construirMetadataArquivo
// em adminEnqueteController.js). Usado nos dois lugares do admin que mostram
// prévia de imagem: UploadImagemCapa.js e PersonalizarFundoForm.js.
export function parseMetadataArquivo(metadataStr) {
  if (!metadataStr) return null;
  try {
    return JSON.parse(metadataStr);
  } catch {
    return null;
  }
}

export function formatarTamanhoArquivo(bytes) {
  if (!bytes && bytes !== 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

const TIPO_LABEL = {
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WEBP'
};

export function formatarTipoArquivo(mimetype) {
  return TIPO_LABEL[mimetype] || mimetype || '';
}
